import React from 'react';
import { Hero } from './components/Hero';
import { RestaurantShowcase } from './components/RestaurantShowcase';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-neutral-950 font-sans text-stone-200 selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      <Hero data-id="element-1" />
      <main data-id="element-2">
        <RestaurantShowcase data-id="element-3" />
        <AboutSection data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}